import { ItemCard } from '../../../components/shared/ItemCard';
import SelectionCard from '../../../components/shared/SelectionCard';

/**
 * ValueCard - Display component for values/badges
 *
 * @param {Object} value - Value data with name, icon, color, description
 * @param {string} variant - Display variant: 'default', 'button', 'list'
 * @param {Function} onClick - Click callback
 * @param {boolean} clickable - Enable clickable styling
 * @param {boolean} selected - Whether the value is selected (for button variant)
 * @param {string} className - Additional CSS classes
 */
export default function ValueCard({
  value,
  variant = 'default',
  onClick,
  clickable = false,
  selected = false,
  className = ''
}) {
  if (!value) return null;

  // Use SelectionCard for button variant (QuickIssue selections)
  if (variant === 'button') {
    const hasCustomColor = value.color && value.color !== '#3B82F6';
    const customColor = hasCustomColor ? value.color : null;

    return (
      <SelectionCard
        item={value}
        icon={value.icon}
        color={customColor}
        selected={selected}
        onClick={onClick}
        label={value.name}
        clickable={clickable}
        className={className}
      />
    );
  }

  // Use ItemCard for other variants (list, default)
  const variantMap = {
    default: 'result',
    list: 'list'
  };

  const itemCardVariant = variantMap[variant] || 'result';
  const hasCustomColor = value.color && value.color !== '#3B82F6';
  const customColor = hasCustomColor ? value.color : null;

  return (
    <ItemCard
      type="value"
      data={value}
      variant={itemCardVariant}
      onClick={onClick}
      clickable={clickable}
      customColor={customColor}
      className={className}
    />
  );
}
